import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import IndividualSalesReportAPI from "../../../api/IndividualSalesReportAPI";
import ChartComponent from "../FixedReportChart";

class IndividualLeadsByRentSaleRentSale extends React.Component {
  constructor(props) {
    super(props);

    // Load source options from local storage
    const propertyTransactionOptions = reactLocalStorage.getObject(Constants.Model).property.fields.property_transaction.options;

    this.state = {
      propertyTransactionData: [], 
      propertyTransactionOptions,  
    };
  }

  componentDidMount() {
    // Fetch data from the API
    IndividualSalesReportAPI.getIndividualLeadsByRentSale(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    const filteredData = data.filter(item => item.property_transaction !== 0);
    this.setState({ propertyTransactionData: filteredData });
    
  };

  handleFail = () => {
    console.error("Failed to fetch data");
  };

  render() {
    const { propertyTransactionData, propertyTransactionOptions } = this.state;

    // Create a record of sums for each source option, starting at 0
    const propertyTransactionSums = {};
    propertyTransactionOptions.forEach(option => {
      propertyTransactionSums[option.value] = 0;
    });

    // Fill in the actual values from the API data
    propertyTransactionData.forEach(item => {
      const property_transaction = [item.property_transaction];
      property_transaction.map(type => {
      if (propertyTransactionSums.hasOwnProperty(type)) {
        propertyTransactionSums[type] = item.sum;
      }})
    });

    // Calculate the total sum of all source values
    const totalSum = Object.values(propertyTransactionSums).filter(Boolean).reduce((total, value) => total + value, 0);

    return (
      <ApiUiController inApiCall={false}>
        <div>
          <h2>Property By Rent / Sale Report</h2>
          <hr />
          <div className="row mt-3">
          <Table striped bordered hover className="col-md-6">
            <thead>
              <tr>
                <th>Configuration</th>
                <th>Total Properties</th>
              </tr>
            </thead>
            <tbody>
              {propertyTransactionOptions.map((option, index) => (
                <tr key={index}>
                  <td>{option.label}</td>
                  <td>{propertyTransactionSums[option.value]}</td>
                </tr>
              ))}
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>{totalSum}</strong></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            {/* Add Chart Component */}
            <ChartComponent progressSums={propertyTransactionSums} progressOptions={propertyTransactionOptions} type="bar" />
          </div>
        </div>
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(IndividualLeadsByRentSaleRentSale);
